// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles__spinner___3yVrj","spin":"styles__spin___cnBTI"};